/** Top-level route that renders the blocking maintenance screen. */
export const MAINTENANCE_ROUTE_NAME = 'system-maintenance';

/** Path of {@link MAINTENANCE_ROUTE_NAME}. */
export const MAINTENANCE_ROUTE_PATH = '/maintenance';
